module.exports = __webpack_public_path__ + "public/images/about-11.896ef0b4fd009b5d03c0402cf29482a5.png";